import React, { useState, useEffect } from "react";
import axios from "axios";
import RoomCard from "../../generals/room_card";
import { Link } from "react-router-dom";
import roomImg from "../../../../images/room.jpg";
import "../../../styles/admins/rooms/room_card.css";

const imgStyles = {
  width: "50%",
  height: "100px",
  objectFit: "cover",
  border: "1px solid white",
};

const cardTitleStyles = {
  fontSize: "1.15rem",
  margin: "0",
  fontWeight: "bold",
  color: "rgba(0, 160, 160)",
};

const cardTextStyles = {
  fontSize: "0.9rem",
  margin: "0",
  color: "#555",
};

const discountedPriceStyles = {
  fontSize: "1.16rem",
  color: "#000000",
  fontWeight: "600",
};

function AdminRooms({ handleToast, id }) {
  const [rooms, setRooms] = useState([]);

  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("rooms");
  });

  useEffect(() => {
    // localStorage.removeItem('rooms');
    // const storedRooms = localStorage.getItem("rooms");
    // if (storedRooms) {
    //   setRooms(JSON.parse(storedRooms));
    // } else {
      axios
        .get(`https://api.dectwinhotel.com/api/${id}_rooms/rooms`)
        .then((response) => {
          // Store products in localStorage
          localStorage.setItem("rooms", JSON.stringify(response.data));
          setRooms(response.data);
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            window.location.reload();
          }
          console.error("Error fetching products:", error);
        });
    // }
  }, [id]);

  return (
    // <section>
      <div className="rooms-data container-fluid">
        {rooms.length > 1 && (
          <div className="card-hover">
            <div>
              <img src={roomImg} alt="Card top" style={imgStyles} />
              <img src={roomImg} alt="Card top" style={imgStyles} />
            </div>
            <div
              style={{ padding: "8px" }}
              state={rooms.filter((r) => r.availability_status === 1)}
            >
              <Link
                to="/admin/book-multiroom"
                state={rooms.filter((r) => r.availability_status === 1)}
              >
                <h5 style={cardTitleStyles}>Book Multiple Rooms</h5>
              </Link>

              <p style={cardTextStyles}>
                Book Multiple Rooms for same Guest at once with customizable
                prices.
              </p>

              <div style={{ marginBottom: "8px" }}>
                <span style={discountedPriceStyles}>Price: Customizable</span>
              </div>

              <div className="rooms-data" style={{ justifyContent: "center" }}>
                <Link
                  to="/admin/book-multiroom"
                  state={rooms.filter((r) => r.availability_status === 1)}
                >
                  <button
                    className="btn-styles"
                    style={{ backgroundColor: "rgba(0, 160, 160)" }}
                  >
                    Check In Now
                  </button>
                </Link>
                {/* <Link to="/admin/add-room">
                <button style={editButton}> Edit Room </button>
              </Link> */}
              </div>
            </div>
          </div>
        )}
        {rooms.length > 0 ? (
          rooms.map((room) => (
            <RoomCard
              key={room.room_id}
              roomData={room}
              handleToast={handleToast}
              id={id}
            />
          ))
        ) : (
          <div className="no-rooms-message">
            <i
              style={{ fontSize: "6rem", margin: "30px 10px" }}
              className="fa fa-bed"
            ></i>
            <p>No Rooms Added Yet.</p>
          </div>
        )}
      </div>
    // </section>
  );
}

export default AdminRooms;
